import { cn } from '@/lib/cn';

interface NumberBadgeProps {
  count: number;
  max?: number;
  className?: string;
}

export function NumberBadge({ count, max = 99, className }: NumberBadgeProps) {
  if (count <= 0) return null;
  const display = count > max ? `${max}+` : String(count);
  return (
    <span
      className={cn(
        'inline-flex min-w-[18px] items-center justify-center rounded-full bg-[var(--color-rise)] px-1 text-[10px] font-bold text-white',
        className,
      )}
    >
      {display}
    </span>
  );
}
